import { render, staticRenderFns } from "./EmpresaChip.vue?vue&type=template&id=fdccc9c0&"
import script from "./EmpresaChip.vue?vue&type=script&lang=js&"
export * from "./EmpresaChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports